<template>
  <footer v-if="show" class="vr360-app-footer">
    <ul class="vr360-app-footer__list">
      <li>
        <!-- <button type="button" class="vr360-app-footer__all-stream" @click="changeScope('public')"> -->
        <router-link :to="{ name: 'ListPublicStreams' }" @click.native="changeScope('public')" class="vr360-app-footer__all-stream">
          <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="9" width="20" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="4" y="1" width="14" height="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="4" y="20" width="14" height="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        <!-- </button> -->
        </router-link>
      </li>
      <li>
        <p class="vr360-app-footer__go-live">
          <span class="vr360-app-footer__go-live__wrap">
            <router-link :to="{ name: 'CreateStream' }" class="vr360-app-footer__go-live__btn"></router-link>
          </span>
          <span class="vr360-text-caption vr360-text-text-gray-3 vr360-text-upper">Go live</span>
        </p>
      </li>
      <li>
        <!-- <button type="button" class="vr360-app-footer__all-stream" @click="changeScope('my')"> -->
        <router-link :to="{ name: 'ListMyStreams' }" @click.native="changeScope('my')" class="vr360-app-footer__all-stream">
          <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="5" r="4" stroke="currentColor" stroke-width="2" />
            <path d="M18.9727 21.0099C15.4362 22.3178 12.6904 22.9794 9.98492 22.9995C7.2852 23.0196 4.54545 22.4013 1.02609 21.0247C1.37656 16.5624 5.23561 13 10 13C14.7591 13 18.6149 16.5546 18.9727 21.0099Z" stroke="currentColor" stroke-width="2" />
          </svg>
        <!-- </button> -->
        </router-link>
      </li>
    </ul>
  </footer>
</template>

<script>
import { mapActions } from "vuex";

const arrWhereFooter = ["ListPublicStreams", "ListMyStreams"];

export default {
  name: "FooterList",
  data() {
    return {
      show: true
    };
  },
  created() {
    this.checkToShow(this.$route.name);
  },
  methods: {
    ...mapActions({
      clearStatus: "stream/clearStatus",
    }),
    checkToShow(name) {
      this.show = arrWhereFooter.indexOf(name) > -1;
    },
    changeScope(scope) {
      // this.clearStatus();
    }
  },
  watch: {
    $route(to) {
      this.checkToShow(to.name);
    }
  }
};
</script>

<style lang="scss">
</style>
